import { MentionModel } from './mention.model';
import { DateFacetResponseModel } from './date-facet-response.model';
import { FacetResponseModel } from './facet-response.model';
import { ProminenceFacetModel } from './prominence-facet.model';
import { ProminenceByReachResultModel } from './prominence-by-reach-result.model';
import { NeoFacetResponseModel } from './neo-facet-response.model';
import { WordCloudResponseModel } from './word-cloud-response.model';
import { SearchCriteriaQueryModel } from './search-criteria-query.model';

export class MentionsSearchResponseModel {
    totalResults: number;
    mentions: MentionModel[];
    dateFacetResults: DateFacetResponseModel[];
    facetResults: FacetResponseModel[];
    neoFacetResults: NeoFacetResponseModel[];
    wordCloudResults: WordCloudResponseModel[];
    prominenceFacets: ProminenceFacetModel[];
    prominenceByReachResult?: ProminenceByReachResultModel;
    combinedQuery?: SearchCriteriaQueryModel;

    constructor () {
        this.totalResults = 0;
        this.mentions = [];
        this.dateFacetResults = [];
        this.facetResults = [];
        this.neoFacetResults = [];
        this.wordCloudResults = [];
        this.prominenceFacets = [];
    }
}
